import { useGiftContext } from "./Context/GiftContextProvider";
import AdminGiftForm from "./AdminGiftForm";
import GiftForm from "./GiftForm";

const GiftFormContainer = () => {
  const { admin } = useGiftContext();

  return <>{admin ? <AdminGiftForm /> : <GiftForm />}</>;
};

export default GiftFormContainer;
